var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.055,
    height: 16.333,
    viewBox: "0 0 19.055 16.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M5.4,4A3.41,3.41,0,0,0,2,7.4V16.93a3.41,3.41,0,0,0,3.4,3.4h12.25a3.41,3.41,0,0,0,3.4-3.4V7.4a3.41,3.41,0,0,0-3.4-3.4Zm0,1.361h12.25a2.019,2.019,0,0,1,1.87,1.216L14.275,11.36a4.245,4.245,0,0,1-5.6.016Q6.034,9.239,3.39,7.1A2.014,2.014,0,0,1,5.4,5.361Zm14.292,2.9V16.93a2.022,2.022,0,0,1-2.042,2.042H5.4A2.022,2.022,0,0,1,3.361,16.93v-8.1L7.8,12.416a5.617,5.617,0,0,0,7.4-.051Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailWhite);
export default __webpack_public_path__ + "static/media/mail-white.9de3d6ede02de8a915faafa803c6ab1e.svg";
export { ForwardRef as ReactComponent };